import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f8dd91c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card__read__more" }, "Read more about this character", -1))
const _hoisted_4 = { class: "card__wrapper__text" }
const _hoisted_5 = { class: "card__text" }


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null,
    name: null,
    image: null
  },
  setup(__props: any) {

const props = __props as {
  id: number;
  name: string;
  image: string;
}

// eslint-disable-next-line


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'details', params: { id: __props.id } }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "card__img",
          src: __props.image,
          alt: `picture of ${__props.name}`
        }, null, 8, _hoisted_2),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.name), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})